<template>
  <div class="user-info-container" :class="mode">
    <div class="avatar" v-if="showInfo.icon !== undefined">
      <img :src="showInfo.icon" alt="" />
    </div>
    <div class="user-info medium" :class="[mode, { center: showCenter }]">
      <div
        class="info-item name bold"
        :class="{ langText: langText }"
        v-if="showInfo.nickname !== undefined"
      >
        <AutoFitMutilComp
          :text-align="showCenter ? 'center' : $i18n.locale === 'AR' ? 'right' : 'left'"
          multi-line
          height="100%"
          :max-font-size="0.4"
          :text="showInfo.nickname"
        ></AutoFitMutilComp>
      </div>
      <div class="info-item id" :class="{ langText: langText }">
        <AutoFitComponent :align="showCenter ? 'center' : $i18n.locale === 'AR' ? 'right' : 'left'"
          >{{ $t('game.userId') }}{{ showInfo.role_id }}</AutoFitComponent
        >
      </div>
      <div
        class="info-item state"
        :class="{ langText: langText }"
        v-if="showInfo.extra_info && showInfo.extra_info.value"
      >
        <AutoFitComponent :align="showCenter ? 'center' : $i18n.locale === 'AR' ? 'right' : 'left'">
          {{ $t(`extra_info.kingdom_${$store.state.app.gameId}`)
          }}{{ showInfo.extra_info && showInfo.extra_info.value }}
        </AutoFitComponent>
      </div>
      <div class="info-item level" :class="{ langText: langText }">
        <AutoFitComponent :align="showCenter ? 'center' : $i18n.locale === 'AR' ? 'right' : 'left'">
          <div class="flex">
            {{ $t(`game.mainCityLevel_${$store.state.app.gameId}`) }}
            <div
              class="rank_icon"
              v-if="typeof showInfo.rank === 'string'"
              :style="{ backgroundImage: `url(${showInfo.rank})` }"
            ></div>
            <span class="rank" v-else>{{ showInfo.rank }}</span>
          </div>
        </AutoFitComponent>
      </div>
    </div>
  </div>
</template>

<script>
// import导入组件工具等
export default {
  name: 'UserInfo',
  props: {
    showInfo: {
      type: Object,
      default: () => ({
        icon: '',
        nickname: '',
        role_id: '',
        extra_info: {
          value: '',
        },
        rank: '',
      }),
    },
    // 用户信息模式
    // default 默认模式
    // pay 支付模式
    // choose_role 切换角色模式
    mode: {
      type: String,
      default: 'default',
    },
    // 用户信息宽度
    langText: {
      type: Boolean,
      default: false,
    },
  },
  // 组件方法
  methods: {},
  computed: {
    showCenter() {
      if (this.showInfo.icon || this.mode === 'pay') return false
      let num = 0
      if (this.showInfo.nickname) num++
      if (this.showInfo.role_id) num++
      if (this.showInfo.extra_info && this.showInfo.extra_info.value) num++
      if (this.showInfo.rank) num++
      return num <= 2
    },
  },
  // 侦听器
  watch: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.user-info-container {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &.choose_role {
    .avatar {
      height: 48px;
      width: 48px;
    }
    .user-info {
      width: 245px;
      padding-top: 3px;
      .info-item {
        width: calc(50% - 2px);
        &:nth-child(even) {
          margin-left: 4px;
        }
      }
    }
  }
  .avatar {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    position: relative;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    background: radial-gradient(circle, transparent, #7095dd);
    font-size: 0;
    & + .user-info {
      margin-left: 10px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info-item {
    width: 120px;
    color: rgba(98, 103, 107, 1);
    line-height: 22px;
    font-size: 13px;
    height: 22px;
    text-align: left;
    flex-shrink: 0;
    &.langText {
      width: 240px;
      max-width: calc(50% - 4px);
    }
    &:nth-child(even) {
      margin-left: 8px;
    }
    &:nth-child(n + 3) {
      order: 3;
    }
    &.name {
      font-size: 15px;
      color: #21272a;
      height: 28px;
      margin-top: -3px;
      line-height: 1.1;
      margin-bottom: -3px;
    }
  }
  .rank_icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 4px;
  }
  .user-info {
    display: flex;
    flex-wrap: wrap;
    &.center {
      width: 100%;
      justify-content: center;
      align-items: center;
    }
    &::after {
      content: '';
      flex-basis: 100%;
      height: 0;
      order: 2; /* 控制伪元素的位置（排在第 2 个元素后） */
    }
    &.pay {
      .avatar {
        width: 34px;
        height: 34px;
      }
      .info-row {
        .info-item {
          width: 146px;
          & + .info-item {
            margin-left: 4px;
          }
        }
      }
    }
  }
}
</style>
